import { useMemo } from 'react';
import { ApiLoader, useApiResource } from './apiHelpers';

export interface PostageZone {
  zoneId: number;
  name: string;
  quantity: number;
}

export interface PostageProduct {
  zoneDelayId: number;
  delayId: number;
  name: string;
  unitPrice: number;
  vatValue: number | null;
}

export interface PostageDelay {
  id: number;
  name: string;
  // Produits disponibles par zone (clé : zoneId), du moins cher au plus cher
  products: Record<string, PostageProduct[]>;
}

export interface MailingPostageOptions {
  weight: number;
  zones: PostageZone[];
  delays: PostageDelay[];
}

const EMPTY_OPTIONS: MailingPostageOptions = { weight: 0, zones: [], delays: [] };

// Délais d'acheminement et tarifs d'affranchissement pour les destinataires de la requête (campagne courrier)
const useMailingPostage = (queryId: number | null) => {
  const load = useMemo<ApiLoader<MailingPostageOptions> | null>(
    () => (queryId === null
      ? null
      : authFetch => authFetch(`/communication/mailing/postage?queryId=${queryId}`, { method: 'GET' })),
    [queryId],
  );
  const { data, loading, error } = useApiResource(load, EMPTY_OPTIONS, "Erreur de chargement des tarifs d'affranchissement");
  return { options: data, loading, error };
};

export default useMailingPostage;
